import React, { Component } from 'react';
import assetWeb from '../assets/web.png';
//import assetCandle from '../assets/candle.png'; //                 <img src={assetCandle} className="candle" alt="Candle" />
import assetLine from '../assets/bottom-line.png';


export class VotePageDecorativeElements extends Component {
    render() {
        return (
            <div>
                <img src={assetWeb} className="web-top" alt="web" />
                <img src={assetLine} className="bottomLine" alt="line" />
            </div>
        )
    }
}